var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFileFailed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.8 1A2.8 2.8 0 002 3.8v16.398a2.8 2.8 0 002.8 2.8h14.4a2.8 2.8 0 002.8-2.8V3.8A2.8 2.8 0 0019.2 1H4.8zm4.663 1.6H4.8a1.2 1.2 0 00-1.2 1.2v16.398a1.2 1.2 0 001.2 1.2h14.4a1.2 1.2 0 001.2-1.2V3.8a1.2 1.2 0 00-1.2-1.2h-3.859l.953 1.901a.8.8 0 01-.108.88l-2.852 3.32.487 6.81a.8.8 0 01-1.513.416L8.73 8.787a.8.8 0 01.021-.755l1.832-3.198L9.462 2.6zm4.089 0h-2.3l.953 1.901a.8.8 0 01-.02.756l-1.832 3.198 1.585 3.163-.224-3.132a.8.8 0 01.191-.578l2.72-3.166L13.552 2.6z",
    fill: "#828282"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileFailed);
export default __webpack_public_path__ + "static/media/file-failed.svg";
export { ForwardRef as ReactComponent };